import { GraphQLVehicleDeviceAssociationRequester } from '@cobliteam/api-lib';
import type { VehicleDeviceAssociationInfoInput, VehicleDeviceAssociationInfoResponse } from '@cobliteam/api-lib/src/__generated__/graphql';
import { useQuery } from '@tanstack/react-query';

export const QUERY_KEY = 'VEHICLE_DEVICE_ASSOCIATIONS';

// Lazy instantiation to avoid circular dependency issues
const getGraphQLVehicleDeviceAssociationRequester = () => new GraphQLVehicleDeviceAssociationRequester();

const useVehicleDeviceAssociation = () => {
  const useVehicleDeviceAssociationsByDevice = (params?: VehicleDeviceAssociationInfoInput) => {
    'use no memo'; // nested in a function the compiler skips; compiled alone it loses the outer scope
    return useQuery<VehicleDeviceAssociationInfoResponse>({
      queryKey: [`${QUERY_KEY}_BY_DEVICE`, JSON.stringify(params)],
      queryFn: () => getGraphQLVehicleDeviceAssociationRequester().getVehicleDeviceAssociationsByDevice(params),
    });
  };

  const useVehicleDeviceAssociationsByVehicle = (params?: VehicleDeviceAssociationInfoInput) => {
    'use no memo'; // nested in a function the compiler skips; compiled alone it loses the outer scope
    return useQuery<VehicleDeviceAssociationInfoResponse>({
      queryKey: [`${QUERY_KEY}_BY_VEHICLE`, JSON.stringify(params)],
      queryFn: () => getGraphQLVehicleDeviceAssociationRequester().getVehicleDeviceAssociationsByVehicle(params),
    });
  };

  return {
    useVehicleDeviceAssociationsByDevice,
    useVehicleDeviceAssociationsByVehicle,
  };
};

export default useVehicleDeviceAssociation;
